/* INTEGY V773 collection view switch: preserve page, sort, stock and theme preview.
   The V577 commerce owner already has a safe DOM-only applyViewMode API.
   Intercept at window capture so older document click handlers cannot navigate. */
(function(){
 'use strict';
 if(!/^\/collections\//i.test(location.pathname))return;
 /* V787: capture real collection pager links before legacy filter handlers.
    Direct page=N URLs work, but a delegated handler can swallow a pager click.
    Keep the shopper's existing filters, sort, and preview state; change only page. */
 window.addEventListener('click',function(event){
   if(event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey ||
      event.shiftKey || event.altKey)return;
   var anchor=event.target&&event.target.closest?event.target.closest('a[href]'):null;
   if(!anchor || anchor.target==='_blank' || anchor.hasAttribute('download'))return;
   /* V787 cleanup: Traxxas custom index pagination already has the V770
      inline repair/click owner in layout/theme.liquid. Do not also intercept
      it here: native and other collection pagers continue to use this guard. */
   if(location.pathname.replace(/\/$/,'')==='/collections/hopups-for-traxxas' &&
      anchor.closest('.integy-v426-filter-pagination'))return;
   if(!anchor.closest('.pagination--container,.productgrid--pagination,.pagination-wrapper,.integy-v426-filter-pagination,.integy-v715-pagination,[data-integy-v651-large-pagination],[data-integy-v664-demand-pagination]'))return;
   var destination,here;
   try { destination=new URL(anchor.href,location.href);here=new URL(location.href); }
   catch(error){return;}
   if(destination.origin!==location.origin || !/^\/collections\//i.test(destination.pathname))return;
   var raw=destination.searchParams.get('page'),page=Number(raw),
       current=Number(here.searchParams.get('page')||'1');
   if(!raw || !Number.isSafeInteger(page) || page<1)return;
   if(page===current && destination.pathname===here.pathname)return;
   /* Paginate the current collection; never follow a malformed cross-collection pager href. */
   here.searchParams.set('page',String(page));
   /* Never propagate the bare grid_list token emitted by some pagers. */
   var view=here.searchParams.get('grid_list');
   if(view!==null && view!=='grid-view' && view!=='list-view')here.searchParams.delete('grid_list');
   event.preventDefault();event.stopPropagation();
   if(event.stopImmediatePropagation)event.stopImmediatePropagation();
   location.assign(here.pathname+here.search+here.hash);
 },true);
 window.addEventListener('click',function(event){
   var target=event.target;
   var button=target&&target.closest?target.closest('button[data-collection-view]'):null;
   if(!button || !button.closest('main#site-main,.productgrid--outer'))return;
   var view=button.getAttribute('data-collection-view');
   if(view!=='grid-view'&&view!=='list-view')return;
   var owner=window.IntegyV449CommerceOwner;
   if(!owner||typeof owner.applyViewMode!=='function')return;
   event.preventDefault();event.stopImmediatePropagation();
   // No navigation: retaining page and every other URL parameter is intentional.
   owner.applyViewMode(view,true);
   if(typeof owner.refresh==='function')window.setTimeout(function(){owner.refresh(document);},0);
 },true);
})();